import { render } from "./BatchQrcode.vue?vue&type=template&id=33c7e793&scoped=true"
import script from "./BatchQrcode.vue?vue&type=script&lang=js"
export * from "./BatchQrcode.vue?vue&type=script&lang=js"

import "./BatchQrcode.vue?vue&type=style&index=0&id=33c7e793&scoped=true&lang=scss"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c7e793"]])

export default __exports__